module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "col1"
    }
  }, [_vm._v("If you want to know about the war between the Alliance of Light and the Ilion Federation, I’ll tell you—straight and true, to the best of my ability. You won’t get all the pious posturing and the high falutin philosophy and moralizing you’ve been hearing from the politicians and generals. I’ve got a different perspective, and I see the war up close and personal—which none of the politicians and damned few of the generals can honestly say. My name is Bart Drak. Friends call me Dragon to my face. Others sometimes use that nickname behind my back. That’s okay with me. I’m a buck sergeant leading a Special Operations Squad in Ranger Battalion of the 1st Combined Regiment. "), _c('em', [_vm._v("Spec Ops")]), _vm._v("—we get the dirtiest, most dangerous jobs. If the mission is something no sane individual would attempt, the big shots dump it on us, Spec Ops—the SOS.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ecca7cd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9781936535408_epub_col1_r1.vue
// module id = 69
// module chunks = 0